import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import { DumboProps } from './types';
import ImageDumbView from './Image';
import UnknownDumbView from './Unknown';
import CommissionDumbView from './Commission';
import LiteratureDumbView from './Literature';
import JournalDumbView from './Journal';
import { useDumboCommon } from './useDumbo';
import StatusDumbView from './Status';

// This is a variant on the normal dumbo, but just for the editor, this removes
// polls etc which cause circular deps...
const MinimalDeviationDumbView: React.FC<DumboProps> = props => {
  const DumboReturn = useDumboCommon(props);
  const cover_attachment = useFlag('cover_attachment');

  if (DumboReturn) {
    return DumboReturn;
  }

  let DumbView;
  switch (getDeviationType(props.deviation)) {
    // these types all have guaranteed thumb image
    case DeviationTypes.IMAGE:
    case DeviationTypes.PDF:
    case DeviationTypes.FILM:
      DumbView = ImageDumbView;
      break;
    // if/when cover_attachment, move into first case above
    case DeviationTypes.TIER:
      DumbView = cover_attachment ? ImageDumbView : UnknownDumbView;
      break;
    case DeviationTypes.JOURNAL:
      DumbView = JournalDumbView;
      break;
    case DeviationTypes.LITERATURE:
      DumbView = LiteratureDumbView;
      break;
    case DeviationTypes.STATUS:
      DumbView = StatusDumbView;
      break;
    case DeviationTypes.COMMISSION:
      DumbView = CommissionDumbView;
      break;
    default:
      DumbView = UnknownDumbView;
  }

  return (
    <ErrorBoundary
      debugComponent="EditorDumbo"
      style={{ width: props.width, height: props.height }}
    >
      <DumbView {...props} />
    </ErrorBoundary>
  );
};
MinimalDeviationDumbView.displayName = 'MinimalDeviationDumbView';

export default MinimalDeviationDumbView;
